<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="customers"
    :title="`${$t('title.selectcustomer')}`"
    idProperty="CustomerId"
    nameProperty="CustomerName"
    allSelectId="customerAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :searchTypes="searchTypes"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="CustomerNumber"
    :defaultItems="defaultItems"
    viewName="CustomerSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      searchTypes: this.$enum.customerSearchType.getAll(),
      customers: [],
      columns: [
        {
          name: "CustomerNumber",
        },
        {
          name: "CustomerName",
        },
      ],
      id: "customerSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      const vm = this;
      this.$api.customers.getPages(dTO).then((data) => {
        vm.customers = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
